import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import RichTextView from './RichTextView'

interface CompetencyCardProps {
  title: string
  description: string
  selfCompleted: number
  guidedCompleted: number
  total: number
  onClick?: () => void
}

const CompetencyCard = ({
  title,
  description,
  selfCompleted,
  guidedCompleted,
  total,
  onClick,
}: CompetencyCardProps) => {
  const selfProgress = total > 0 ? Math.round((selfCompleted / total) * 100) : 0
  const guidedProgress =
    total > 0 ? Math.round((guidedCompleted / total) * 100) : 0

  return (
    <div
      className="card gw-competency-area-card"
      role={onClick ? 'button' : undefined}
      onClick={onClick}
    >
      <div className="card-body gw-competency-area-body">
        <div className="d-flex justify-content-between align-items-start gap-3">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <h6 className="gw-competency-area-title mb-0">{title}</h6>
              <div className="gw-competency-area-badges">
                <span className="gw-competency-area-badge gw-competency-area-badge--self">
                  Self: {selfCompleted ?? selfCompleted} of {total}
                </span>
                <span className="gw-competency-area-badge gw-competency-area-badge--guided">
                  Guided: {guidedCompleted ?? 0} of {total}
                </span>
              </div>
            </div>
            <RichTextView
              html={description}
              className="gw-competency-area-description mb-3"
            />
            <div className="gw-competency-area-progress-container">
              <div className="gw-competency-area-progress">
                <div
                  className="gw-competency-area-progress-bar gw-competency-area-progress-bar--self"
                  style={{ width: `${selfProgress}%` }}
                />
              </div>
              <div className="gw-competency-area-progress">
                <div
                  className="gw-competency-area-progress-bar gw-competency-area-progress-bar--guided"
                  style={{ width: `${guidedProgress}%` }}
                />
              </div>
            </div>
          </div>
          <FontAwesomeIcon
            icon={faChevronRight}
            className="gw-competency-area-icon"
          />
        </div>
      </div>
    </div>
  )
}

export default CompetencyCard
